<template>
  <Paper class="analysisReport">
    <el-row type="flex" class="row-bg">
      <!-- <el-col id="search-input-guide" :span="1">
        <div :class="[panorama, componentPan]">
          <span @click="showPanoramaCar(1)" class="register-number">注册量</span>
          <span @click="showPanoramaCar(2)" class="analysis-number">解析量</span>
        </div>
      </el-col> -->
      <el-col :span="24">
        <el-row>
          <el-col class="analysisReport-search-item">
            <span class="analysisReport-startDate-typeselect">
              <el-select v-model="DateText" @change="changeDate" placeholder="请选择">
                <el-option
                  v-for="item in Dateoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </span>
          </el-col>
          <el-col class="analysisReport-search-item" v-if="!changeYearMoth">
            <span class="startDate-content">
                        <el-date-picker
                          v-model="searchData.year"
                          type="year"
                          value-format="yyyy"
                          placeholder="选择年">
                        </el-date-picker>
                      </span>
          </el-col>
          <el-col class="analysisReport-search-item" v-if="changeYearMoth">
            <span class="startDate-content">
                        <el-date-picker
                          v-model="searchData.month"
                          align="left"
                          type="month"
                          value-format="yyyy-M"
                          placeholder="请选择月份"
                        ></el-date-picker>
                      </span>
          </el-col>
          <el-col class="analysisReport-search-item">
            <span class="query-condition-content query-condition-icon">
                      <el-input v-model="searchData.prefixCode" disabled placeholder="请选择企业前缀"></el-input>
                      <div class="query-condition-icon-img" @click="selectEnterprise">
                        <img src="../../../assets/images/add-option.svg" alt="" />
                      </div>
                    </span>
          </el-col>
          <div>
            <el-button type="primary"  size="mini" :loading="searchReportLoading" @click="searchReport" icon='el-icon-search'>
                  查 询
            </el-button>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <div class="analysisReport-ecahrt">
      <div v-if="!showtrue" class="showHint">暂无数据</div>
      <report-echart
        v-if="showtrue"
        :ecahrtID="analysisReportEchart"
        :maxNumber="maxNumber"
        :titleText="titleText"
        :XAxisData="XAxisData"
        :seriseData="seriseData">
      </report-echart>
      <div :class="[panorama, componentPan]">
          <span @click="showPanoramaCar(1)" class="register-number">注册量</span>
          <span @click="showPanoramaCar(2)" class="analysis-number">解析量</span>
      </div>
      <div  v-if="showtrue&&changeYearMoth" class="ecahrt-unit">单位: 次/日</div>
      <div v-else class="ecahrt-unit">单位: 次/月</div>
    </div>
    <!-- 选择企业 -->
    <el-dialog class="templateClass" title="企业前缀" :visible.sync="enterpriseDialog" width="50%">
      <templateComponents
        ref="templateComponents"
        :config="enterpriseDialogJson"
        :pageTotal="enterpriseDialogTotal"
        :tableData="enterpriseDialogData"
        @onSearchChange="onSearchChange"
        @onSelectionChange="enterpriseDialogSelec"
        @pageChange="enterpriseDialogPageChange"
        @sizeChange="enterpriseDialogSizeChange"
      ></templateComponents>
      <span slot="footer" class="dialog-footer">
        <el-button @click="enterpriseDialog = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="enterpriseDialogSure" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import ReportEchart from '../../../components/reportEchart/Index';
import templateComponents from '../../../components/IdentityComponent/Main.vue';
import enterpriseDialogJson from './enterprise.json';
import { getAnalysisReport, arrmax, getEnterprise } from '../../../api/reportManagement';
import { mapGetters } from 'vuex';
export default {
    name: 'analysisReport',
    components: { Paper, ReportEchart, templateComponents },
    data() {
        return {
            panorama: 'panorama',
            componentPan: 'componentPan',
            enterpriseDialogJson: enterpriseDialogJson,
            enterpriseDialog: false,
            enterpriseDialogTotal: 0,
            enterpriseDialogData: [],
            DateText: '2',
            changeYearMoth: true,
            Dateoptions: [
                {
                    value: '1',
                    label: '年份'
                },
                {
                    value: '2',
                    label: '月份'
                }
            ],
            searchData: {
                year: '',
                month: '',
                prefixCode: '',
                action: 'registry'
            },
            titleText: '',
            maxNumber: 0,
            XAxisData: [],
            showtrue: false,
            analysisReportEchart: 'analysisReportEchart',
            seriseData: [
                {
                    name: '',
                    type: 'bar',
                    data: [],
                    barWidth: '12px',
                    barCategoryGap: '10%',
                    itemStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                                [
                                    {
                                        offset: 0,
                                        color: '#8ECFFF' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: '#AFF0F1' // 100% 处的颜色
                                    }
                                ],
                                false
                            )
                        }
                    }
                }
            ],
            page: {
                pageSize: 10,
                pageNo: 1
            },
            onSearchdata: {},
            enterpriseSelect: [],
            templatesearchData: [],
            searchReportLoading: false
        };
    },
    methods: {
        changeDate(data) {
            if (+data === 1) {
                this.changeYearMoth = false;
                this.searchData.month = '';
                this.getTime();
            } else {
                this.changeYearMoth = true;
                this.searchData.year = '';
                this.getMonth();
            }
        },
        showPanoramaCar(data) {
            if (data === 1 && this.showtrue) {
                this.panorama = 'panorama';
                this.searchData['action'] = 'registry';
                const params = {
                    ...this.searchData
                };
                this.getData(params);
            }
            if (data === 2 && this.showtrue) {
                this.panorama = 'car';
                this.searchData['action'] = 'parse';
                const params = {
                    ...this.searchData
                };
                this.getData(params);
            }
        },
        searchReport() {
            const params = {
                ...this.searchData
            };
            this.getData(params);
        },
        getData(params) {
            if (params.month) {
                const dateArray = params.month.split('-');
                params.year = dateArray[0];
                params.month = dateArray[1];
            };
            getAnalysisReport(params).then(res => {
                if (+res.code === 0) {
                    this.XAxisData = [];
                    const otherDate = [];
                    res.data.map((item, index) => {
                        this.XAxisData.push(index + 1);
                        otherDate.push(item.count);
                    });
                    this.maxNumber = arrmax(otherDate);
                    this.seriseData[0].data = otherDate;
                    this.seriseData[0].name = res.data[0].action === 'registry' ? '注册量' : '解析量';
                    this.titleText = res.data[0].title;
                    this.showtrue = true;
                }
            }).catch(res => {
            });
        },
        getTime() {
            const statsTime = new Date();
            const year = statsTime.getFullYear().toString();
            this.searchData.year = year;
        },
        getMonth() {
            const statsTime = new Date();
            const year = statsTime.getFullYear().toString();
            const month = statsTime.getMonth() + 1;
            this.searchData.month = year + '-' + month;
        },
        // 选择企业
        getEnterprise(params) {
            params['registerStatus'] = 'Y';
            getEnterprise(params).then(res => {
                if (+res.code === 0) {
                    this.enterpriseDialogData = res.data.list;
                    this.enterpriseDialogTotal = res.data.totalCount;
                }
            });
        },
        selectEnterprise() {
            if (this.$refs.templateComponents) {
                this.$refs.templateComponents.$refs.SearchLsit.clearsearchData();
            }
            this.enterpriseDialog = true;
            const params = {
                ...this.page
            };
            this.getEnterprise(params);
        },
        onSearchChange(data) {
            this.onSearchdata = data;
            const params = {
                ...this.page,
                ...this.onSearchdata
            };
            this.getEnterprise(params);
        },
        enterpriseDialogSelec(data) {
            this.enterpriseSelect = data;
        },
        enterpriseDialogPageChange(pageNo) {
            this.page.pageNo = pageNo;
            const params = {
                ...this.page,
                ...this.onSearchdata
            };
            this.getEnterprise(params);
        },
        enterpriseDialogSizeChange(pageSize) {
            this.page.pageSize = pageSize;
            const params = {
                ...this.page,
                ...this.onSearchdata
            };
            this.getEnterprise(params);
        },
        enterpriseDialogSure() {
            if (this.enterpriseSelect.length > 0) {
                this.searchData.prefixCode = this.enterpriseSelect[0].prefixCode;
                this.enterpriseDialog = false;
            }
        },
        getDefalutPrefixCode() {
            const params = {
                tenantCode: this.currentTenant.tenantCode
            };
            this.searchData.prefixCode = params.tenantCode;
            // getEnterprise(params).then(res => {
            //     if (+res.code === 0) {
            //       console.log(res.data.list[0].prefixCode)
            //         this.searchData['prefixCode'] = res.data.list[0].prefixCode;
            //     }
            // });
        }
    },
    mounted() {
        this.getMonth();
        this.getDefalutPrefixCode();
        this.searchReport();
    },
    computed: {
        ...mapGetters(['user', 'currentTenant'])
    },
    beforeRouteEnter (to, from, next) {
        if (from.path === '/homePage') {
            next(vm => {
                if (vm.$route.query.prefixCode) {
                    vm.DateText = '2';
                    vm.changeYearMoth = true;
                    const month = new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1);
                    vm.searchData.month = month;
                    vm.searchData['prefixCode'] = vm.$route.query.prefixCode;
                    vm.searchReport();
                }
            });
        } else {
            next();
        }
    }
};
</script>
<style lang="less">
.analysisReport {
  .analysisReport-search-item{
    width: 190px;
    margin-right: 10px;
    .el-select{
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
      .el-icon-date{
        display: none;
      }
      .el-input__inner{
        padding-left: 10px;
      }
    }
  }
  .register-number,
  .analysis-number {
    background: #fff;
    border: 1px solid #d9d9d9;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
    padding: 3px 9px;
    cursor: pointer;
  }
  .panorama .register-number,
  .car .analysis-number {
    color: #4285f5;
    border: 1px solid #4285f5;
  }
  .componentPan {
    display: flex;
    align-items: center;
    position: absolute;
    top: 10px;
    left: 3%;
  }
  .query-condition-icon {
     position: relative;
    .query-condition-icon-img {
      cursor: pointer;
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      right: 0;
      img {
        position: absolute;
        right: 4px;
        top: 4px;
      }
    }
  }
  .analysisReport-ecahrt {
    margin-top: 20px;
    height: calc(100vh - 10vw - 20px);
    position: relative;
    .ecahrt-unit {
        position: absolute;
        top: 20px;
        right: 2vw;
        font-size: 14px;
        color: rgba(0,0,0,0.45);
    }
  }
  .templateClass {
    .nPanel .el-table {
      height: calc(100vh - 500px) !important;
    }
  }
  .showHint {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #898c8c;
  }
  .analysisReport-startDate-type {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
  }
  #analysisReportEchart {
    height: 100%;
    width: 100%;
  }
}
</style>